/** LDT compare page: spec row injection, picker allowlist, sticky offset, horizontal scroll sync (`ldt-compare.css`). */
(function () {
  if (!document.body.classList.contains('ldt-compare-page')) return;

  var lastSpecSyncFingerprint = '';

  var ldtCompareSubtreeObserver = null;
  var observerPauseDepth = 0;

  function pauseLdtCompareSubtreeObserver() {
    if (ldtCompareSubtreeObserver) ldtCompareSubtreeObserver.disconnect();
  }

  function resumeLdtCompareSubtreeObserver() {
    var el = document.getElementById('ldt-app-proxy-root');
    if (!ldtCompareSubtreeObserver || !el) return;
    try {
      ldtCompareSubtreeObserver.observe(el, { childList: true, subtree: true });
    } catch (eResume) {}
  }

  function withLdtCompareSubtreeObserverPaused(fn) {
    observerPauseDepth++;
    if (observerPauseDepth === 1) pauseLdtCompareSubtreeObserver();
    try {
      fn();
    } finally {
      observerPauseDepth--;
      if (observerPauseDepth === 0) resumeLdtCompareSubtreeObserver();
    }
  }

  var REQUIRED_SPEC_KEYS = [
    'length',
    'capacity',
    'water_type',
    'drive_type',
    'modular_pieces',
    'transport_type',
    'stability',
    'performance_level',
    'best_for',
    'modular_design',
    'motor_compatibility',
    'rod_holders',
    'drive_recess',
    'side_bar',
    'rudder_replace',
    'rear_transom',
    'bow',
    'storage_capacity',
    'seat_type',
  ];

  var SPEC_ROWS_MAIN = [
    { key: 'length', label: 'Length' },
    { key: 'capacity', label: 'Capacity' },
    { key: 'water_type', label: 'Water Type' },
    { key: 'drive_type', label: 'Drive Type' },
    { key: 'modular_pieces', label: 'Number of modular pieces' },
    { key: 'transport_type', label: 'Transport Type' },
    { key: 'stability', label: 'Stability' },
    { key: 'performance_level', label: 'Performance Level' },
    { key: 'best_for', label: 'Best For' },
    { key: 'modular_design', label: 'Modular design' },
    { key: 'motor_compatibility', label: 'Motor compatibility' },
    { key: 'rod_holders', label: 'Rod holders' },
    { key: 'storage_capacity', label: 'Storage capacity' },
    { key: 'seat_type', label: 'Seat Type' },
  ];

  var SPEC_ROWS_TROLLING = [
    { key: 'drive_recess', label: 'Drive Recess' },
    { key: 'side_bar', label: 'Side Bar' },
    { key: 'rudder_replace', label: 'Rudder Replace' },
    { key: 'rear_transom', label: 'Rear Transom' },
    { key: 'bow', label: 'Bow' },
  ];

  function specValueToString(v) {
    if (v === null || v === undefined) return '';
    return String(v).trim();
  }

  function unwrapSpecsObject(raw) {
    if (raw == null) return null;
    if (typeof raw === 'string') {
      var s = raw.trim();
      if (!s || s === 'null') return null;
      try {
        raw = JSON.parse(s);
      } catch (e) {
        return null;
      }
    }
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
    if (raw.specs && typeof raw.specs === 'object' && !Array.isArray(raw.specs)) return raw.specs;
    var inner = raw.value;
    if (inner != null && typeof inner === 'object' && !Array.isArray(inner)) return inner;
    return raw;
  }

  function normalizeSpec(spec) {
    var src = unwrapSpecsObject(spec);
    if (!src || typeof src !== 'object') return null;
    var o = {};
    for (var i = 0; i < REQUIRED_SPEC_KEYS.length; i++) {
      var k = REQUIRED_SPEC_KEYS[i];
      o[k] = specValueToString(src[k]);
    }
    o.badge = specValueToString(src.badge);
    return o;
  }

  function createBoolIcon(kind) {
    var el = document.createElement('span');
    el.className = 'ldt-compare-spec-icon ldt-compare-spec-icon--' + kind;
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', kind === 'yes' ? 'Yes' : 'No');
    if (kind === 'yes') {
      el.innerHTML =
        '<svg class="ldt-compare-spec-icon__svg" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    } else {
      el.innerHTML =
        '<svg class="ldt-compare-spec-icon__svg" width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>';
    }
    return el;
  }

  /** Capitalize first alphabetic character (supports letters after digits / punctuation, e.g. "10 ft" → "10 Ft"). */
  function capitalizeLeadingDisplayChar(text) {
    var s = String(text || '');
    if (!s) return s;
    try {
      var letterRe = /\p{L}/u;
      for (var i = 0; i < s.length; ) {
        var cp = s.codePointAt(i);
        var ch = String.fromCodePoint(cp);
        var jump = ch.length;
        if (letterRe.test(ch))
          return s.slice(0, i) + ch.toLocaleUpperCase(undefined) + s.slice(i + jump);
        i += jump;
      }
    } catch (_eRe) {}
    var m = /[a-zA-Z]/.exec(s);
    if (!m || m.index == null) return s;
    var j = m.index;
    var c = s.charAt(j);
    return s.slice(0, j) + c.toUpperCase() + s.slice(j + 1);
  }

  function renderCompareCell(raw) {
    var t = (raw || '').trim();
    var lower = t.toLowerCase();
    if (!t) {
      var empty = document.createElement('span');
      empty.className = 'ldt-compare-spec-text ldt-compare-spec-text--empty';
      empty.textContent = '—';
      return empty;
    }
    if (/^[✓✔✓]\s*$/.test(t) || lower === 'yes' || lower === 'true' || lower === 'y') {
      return createBoolIcon('yes');
    }
    if (/^[✗✗]\s*$/.test(t) || lower === 'x' || t === '-' || t === '—' || lower === 'no' || lower === 'false' || lower === 'n') {
      return createBoolIcon('no');
    }
    var parenNo = t.match(/^(-|—|✗|✗)\s*\(([^)]+)\)\s*$/);
    if (parenNo) {
      var wb = document.createElement('span');
      wb.className = 'ldt-compare-spec-hybrid';
      wb.appendChild(createBoolIcon('no'));
      var tb = document.createElement('span');
      tb.className = 'ldt-compare-spec-hybrid-text';
      tb.textContent = ' (' + capitalizeLeadingDisplayChar(parenNo[2].trim()) + ')';
      wb.appendChild(tb);
      return wb;
    }
    if (/^[✓✔✓]\s+.+/.test(t)) {
      var wy = document.createElement('span');
      wy.className = 'ldt-compare-spec-hybrid';
      wy.appendChild(createBoolIcon('yes'));
      var ty = document.createElement('span');
      ty.className = 'ldt-compare-spec-hybrid-text';
      ty.textContent = ' ' + capitalizeLeadingDisplayChar(t.replace(/^[✓✔✓]\s+/, '').trim());
      wy.appendChild(ty);
      return wy;
    }
    var span = document.createElement('span');
    span.className = 'ldt-compare-spec-text';
    span.textContent = capitalizeLeadingDisplayChar(t);
    return span;
  }

  function appendCellContent(innerShell, rawText) {
    innerShell.textContent = '';
    var frag = renderCompareCell(rawText);
    innerShell.appendChild(frag);
    innerShell.classList.remove('ldt-compare-spec-val--has-icon', 'ldt-compare-spec-val--hybrid');
    if (innerShell.querySelector('.ldt-compare-spec-icon')) innerShell.classList.add('ldt-compare-spec-val--has-icon');
    if (innerShell.querySelector('.ldt-compare-spec-hybrid')) innerShell.classList.add('ldt-compare-spec-val--hybrid');
  }

  function headerHeightFallback() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    var n = parseFloat(raw);
    return Number.isFinite(n) ? n : 0;
  }

  function stickyChromeBottomPx() {
    var main = document.getElementById('MainContent');
    var before = main && main.previousElementSibling;
    var maxBottom = 0;

    if (before && before.querySelectorAll) {
      var sections = before.querySelectorAll(':scope > [id^="shopify-section-"]');
      for (var i = 0; i < sections.length; i++) {
        var r = sections[i].getBoundingClientRect();
        if (r.bottom <= 0) continue;
        if (r.top > 280) continue;
        if (r.bottom > maxBottom) maxBottom = r.bottom;
      }
    }

    var hdr = document.querySelector('.section-header');
    if (hdr) {
      var hr = hdr.getBoundingClientRect();
      if (hr.bottom > maxBottom && hr.top < 280) maxBottom = hr.bottom;
    }

    return Math.max(0, Math.ceil(maxBottom));
  }

  function syncLdtStickyTop() {
    var px = stickyChromeBottomPx();
    if (px < 1) px = headerHeightFallback();
    document.body.style.setProperty('--ldt-sticky-top', px + 'px');

    var root = document.getElementById('ldt-app-proxy-root');
    if (root) {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      var pad = 48;
      var pane = Math.max(280, Math.floor(vh - px - pad));
      root.style.setProperty('--ldt-pane-max-h', pane + 'px');
    }
  }

  function loadSpecsByHandle() {
    var el = document.getElementById('ldt-compare-specs-data');
    var out = {};
    if (!el) return out;
    var raw = el.textContent.trim();
    if (!raw) return out;
    try {
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return out;
      arr.forEach(function (row) {
        if (!row || !row.handle || row.specs == null) return;
        var unwrapped = unwrapSpecsObject(row.specs);
        if (unwrapped && typeof unwrapped === 'object') {
          var normalized = normalizeSpec(unwrapped);
          if (normalized) out[String(row.handle)] = normalized;
        }
      });
      return out;
    } catch (e) {
      return out;
    }
  }

  function parseShopifyProductGidToId(v) {
    if (!v || typeof v !== 'string') return null;
    var s = v.trim();
    if (/^\d+$/.test(s)) return s;
    try {
      s = decodeURIComponent(s);
    } catch (eDec) {}
    var m = s.match(/^gid:\/\/shopify\/Product\/(\d+)\s*$/i);
    return m ? String(m[1]) : null;
  }

  function loadAllowedPickerGate() {
    var handleSet = new Set();
    var idSet = new Set();

    function ingestRow(row) {
      if (!row) return;
      if (typeof row === 'string') {
        var sx = row.trim();
        if (sx) handleSet.add(sx.toLowerCase());
        return;
      }
      if (typeof row === 'object') {
        if (row.handle) handleSet.add(String(row.handle).trim().toLowerCase());
        if (row.id != null && row.id !== '') idSet.add(String(row.id));
      }
    }

    var elPick = document.getElementById('ldt-compare-picker-allow-handles');
    if (elPick) {
      try {
        var rawP = elPick.textContent.trim();
        if (rawP) {
          var arrP = JSON.parse(rawP);
          if (Array.isArray(arrP)) arrP.forEach(ingestRow);
        }
      } catch (ePick) {}
    }

    var elSpecs = document.getElementById('ldt-compare-specs-data');
    if (elSpecs) {
      try {
        var rawS = elSpecs.textContent.trim();
        if (rawS) {
          var arrS = JSON.parse(rawS);
          if (Array.isArray(arrS)) arrS.forEach(ingestRow);
        }
      } catch (eSpec) {}
    }

    return { handleSet: handleSet, idSet: idSet };
  }

  function extractHandleFromProductHref(href) {
    if (!href) return null;
    var m = String(href).match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    if (!m || !m[1]) return null;
    try {
      return decodeURIComponent(m[1]).toLowerCase();
    } catch (eH) {
      return m[1].toLowerCase();
    }
  }

  function handleFromPickerDomNode(node) {
    if (!node || node.nodeType !== 1) return null;
    var ds = node.dataset || {};
    if (ds.productHandle) return String(ds.productHandle).trim().toLowerCase();
    if (ds.handle) return String(ds.handle).trim().toLowerCase();
    var lk = node.querySelector('a[href*="/products/"]');
    if (lk) return extractHandleFromProductHref(lk.getAttribute('href'));
    var href = node.getAttribute('href');
    if (href && href.indexOf('/products/') !== -1) return extractHandleFromProductHref(href);
    return null;
  }

  function handleFromNativeOption(opt) {
    if (!opt || opt.tagName !== 'OPTION') return null;
    var fromDom = handleFromPickerDomNode(opt);
    if (fromDom) return fromDom;
    var v = (opt.value || '').trim();
    if (!v) return null;
    if (/^gid:\/\/shopify\/Product/i.test(v)) return null;
    if (/^[a-z0-9][a-z0-9_-]*$/i.test(v)) return v.toLowerCase();
    if (v.indexOf('/products/') !== -1) return extractHandleFromProductHref(v);
    return null;
  }

  function nativeProductOptionAllowed(opt, gate) {
    var v = (opt.value || '').trim();
    if (!v) return true;

    var gidId = parseShopifyProductGidToId(v);
    if (gidId) {
      return gate.idSet.has(gidId);
    }

    var h = handleFromNativeOption(opt);
    if (h) return gate.handleSet.has(h);

    if (gate.idSet.size === 0 && gate.handleSet.size === 0) return true;

    return false;
  }

  /**
   * Native `<select>` UI (Safari iOS, Safari macOS, many WKWebViews) still lists `hidden`+`disabled`
   * `<option>`s as gray rows — remove disallowed options whenever the gate lists comparable products.
   */
  function syncProductPickerAllowlist() {
    document.body.querySelectorAll('select.ldt-cp-variant-select option').forEach(function (opt) {
      opt.hidden = false;
      opt.disabled = false;
    });

    var gate = loadAllowedPickerGate();
    if (gate.idSet.size === 0 && gate.handleSet.size === 0) return;

    function filterOneSelect(sel) {
      var opts = Array.prototype.slice.call(sel.options);
      var i;
      var needsReset = false;

      for (i = 0; i < opts.length; i++) {
        var opt = opts[i];
        if (!opt.parentNode || opt.parentNode !== sel) continue;

        var v = (opt.value || '').trim();
        if (!v) {
          opt.hidden = false;
          opt.disabled = false;
          continue;
        }

        var allow = nativeProductOptionAllowed(opt, gate);
        if (allow) {
          opt.hidden = false;
          opt.disabled = false;
          continue;
        }

        if (opt.selected) needsReset = true;
        opt.remove();
      }

      if (needsReset) {
        for (i = 0; i < sel.options.length; i++) {
          var o = sel.options[i];
          var ov = (o.value || '').trim();
          if (!o.hidden && !o.disabled && !ov) {
            sel.selectedIndex = i;
            break;
          }
        }
      }
    }

    document.body.querySelectorAll('select.ldt-cp-product-select').forEach(filterOneSelect);

    document.body.querySelectorAll('.ldt-cp-compare-variant-picker select').forEach(function (sel) {
      if (sel.classList.contains('ldt-cp-collection-select')) return;
      if (sel.classList.contains('ldt-cp-variant-select')) return;
      filterOneSelect(sel);
    });

    document.body.querySelectorAll('[role="listbox"] [role="option"]').forEach(function (el) {
      var dv = el.getAttribute('data-value') || (el.dataset && el.dataset.value) || '';
      var pid = parseShopifyProductGidToId(String(dv));
      if (pid) {
        el.classList.toggle('ldt-compare-picker-option-hidden', !gate.idSet.has(pid));
        return;
      }
      var hx = handleFromPickerDomNode(el);
      if (hx === null) return;
      el.classList.toggle('ldt-compare-picker-option-hidden', !gate.handleSet.has(hx));
    });

    document.body.querySelectorAll('[role="menu"] [role="menuitem"]').forEach(function (el) {
      var dv = el.getAttribute('data-value') || (el.dataset && el.dataset.value) || '';
      var pid2 = parseShopifyProductGidToId(String(dv));
      if (pid2) {
        el.classList.toggle('ldt-compare-picker-option-hidden', !gate.idSet.has(pid2));
        return;
      }
      var hx2 = handleFromPickerDomNode(el);
      if (hx2 === null) return;
      el.classList.toggle('ldt-compare-picker-option-hidden', !gate.handleSet.has(hx2));
    });
  }

  var pickerAllowTimer = null;
  var pickerAllowGen = 0;
  function scheduleProductPickerAllowlist() {
    pickerAllowGen += 1;
    var gen = pickerAllowGen;
    if (pickerAllowTimer) clearTimeout(pickerAllowTimer);
    pickerAllowTimer = setTimeout(function () {
      pickerAllowTimer = null;
      if (gen !== pickerAllowGen) return;
      withLdtCompareSubtreeObserverPaused(syncProductPickerAllowlist);
    }, 320);
  }

  /**
   * LDT opens with an unchosen collection placeholder; when the storefront only exposes one real collection
   * (typically "All Kayaks") we select it immediately so compare data + picker load without extra clicks.
   * Matches snippet fallback handle in `ldt-compare-specs-json.liquid`.
   */
  var ALL_KAYAKS_COLLECTION_FRAGMENT = 'modular-kayaks-inflatable-fishing-pedal-drive-propeller-fin';

  function isPlaceholderCollectionOption(opt) {
    if (!opt) return true;
    var v = (opt.value || '').trim();
    var txt = (opt.textContent || opt.innerText || '').replace(/\s+/g, ' ').trim();
    if (!v) {
      if (!txt) return true;
      if (/^(select|choose|pick)/i.test(txt)) return true;
      if (/^[-—]+$/.test(txt)) return true;
    }
    return false;
  }

  function comparableCollectionOptions(sel) {
    var out = [];
    var opts = sel && sel.options;
    if (!opts) return out;
    var i;
    for (i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (o.disabled) continue;
      if (isPlaceholderCollectionOption(o)) continue;
      out.push(o);
    }
    return out;
  }

  function targetCollectionAutoOption(real) {
    if (!real || !real.length) return null;
    if (real.length === 1) return real[0];
    var i;
    for (i = 0; i < real.length; i++) {
      var o = real[i];
      var t = (o.textContent || o.innerText || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var v = (o.value || '').trim().toLowerCase();
      if (/\ball\s*kayaks?\b/.test(t)) return o;
      if (v.indexOf(ALL_KAYAKS_COLLECTION_FRAGMENT) !== -1) return o;
    }
    return null;
  }

  function dispatchSelectNativeChange(sel) {
    if (typeof Event === 'function') {
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var ev;
      try {
        ev = document.createEvent('HTMLEvents');
        ev.initEvent('change', true, false);
        sel.dispatchEvent(ev);
      } catch (eC) {}
    }
  }

  function tryAutoSelectKayakCollection(sel) {
    if (!sel || sel.tagName !== 'SELECT' || sel.dataset.ldtCollectionAutoApplying) return;
    var real = comparableCollectionOptions(sel);
    var targetOpt = targetCollectionAutoOption(real);
    if (!targetOpt) return;
    var curOpt = sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
    var onPlaceholder = !curOpt || isPlaceholderCollectionOption(curOpt);
    if (real.length !== 1 && !onPlaceholder) return;
    if (sel.selectedOptions && sel.selectedOptions[0] === targetOpt) return;

    var opts = sel.options;
    var idx = Array.prototype.indexOf.call(opts, targetOpt);
    if (idx < 0) return;

    sel.dataset.ldtCollectionAutoApplying = '1';
    try {
      sel.selectedIndex = idx;
      dispatchSelectNativeChange(sel);
    } finally {
      delete sel.dataset.ldtCollectionAutoApplying;
    }
  }

  function syncCollectionSelectDefault() {
    var root = document.getElementById('ldt-app-proxy-root');
    if (!root) return;
    root.querySelectorAll('select.ldt-cp-collection-select').forEach(tryAutoSelectKayakCollection);
  }

  var collectionAutoTimer = null;
  var collectionAutoGen = 0;
  function scheduleCollectionSelectDefault() {
    collectionAutoGen += 1;
    var gen = collectionAutoGen;
    if (collectionAutoTimer) clearTimeout(collectionAutoTimer);
    collectionAutoTimer = setTimeout(function () {
      collectionAutoTimer = null;
      if (gen !== collectionAutoGen) return;
      withLdtCompareSubtreeObserverPaused(syncCollectionSelectDefault);
    }, 140);
  }

  var COMPARE_CORNER_LOGO_SRC =
    'https://cdn.shopify.com/s/files/1/0525/7419/1790/files/RY-logo-mini.png?v=1777550207';

  function syncCompareCornerLogo(scope) {
    if (!scope) return;
    scope.querySelectorAll('tr.ldt-cp-compare-list-item-products').forEach(function (tr) {
      var th = tr.querySelector(':scope > th:first-child');
      if (!th) return;
      var label = th.querySelector('.ldt-cp-column-label');
      var normalized = (label ? label.textContent : th.textContent).replace(/\s+/g, ' ').trim();
      if (!/^product$/i.test(normalized)) {
        th.querySelectorAll('.ldt-compare-corner-brand').forEach(function (n) {
          n.remove();
        });
        return;
      }

      var existingImg = th.querySelector('.ldt-compare-corner-brand img');
      if (existingImg && existingImg.getAttribute('src') === COMPARE_CORNER_LOGO_SRC) return;

      th.querySelectorAll('.ldt-compare-corner-brand').forEach(function (n) {
        n.remove();
      });

      if (!label && /^product$/i.test(normalized)) {
        th.textContent = '';
      }

      var wrap = document.createElement('div');
      wrap.className =
        'ldt-compare-corner-brand ldt-cp-flex ldt-cp-items-center ldt-cp-justify-center ldt-cp-w-full';

      var img = document.createElement('img');
      img.className = 'ldt-compare-corner-brand__img';
      img.src = COMPARE_CORNER_LOGO_SRC;
      img.alt = 'Reel Yaks';
      img.decoding = 'async';
      img.loading = 'eager';

      wrap.appendChild(img);
      th.appendChild(wrap);
    });
  }

  function syncStickyToolbarCornerLogo(scope) {
    if (!scope) return;
    scope.querySelectorAll('th.ldt-cp-sticky.ldt-cp-left-0').forEach(function (th) {
      if (!th.querySelector('#showDiff')) return;

      var existingImg = th.querySelector('.ldt-compare-corner-brand--sticky-toolbar img');
      if (existingImg && existingImg.getAttribute('src') === COMPARE_CORNER_LOGO_SRC) return;

      th.querySelectorAll('.ldt-compare-corner-brand--sticky-toolbar').forEach(function (n) {
        n.remove();
      });

      var wrap = document.createElement('div');
      wrap.className =
        'ldt-compare-corner-brand ldt-compare-corner-brand--sticky-toolbar ldt-cp-flex ldt-cp-items-center ldt-cp-justify-center ldt-cp-w-full';

      var img = document.createElement('img');
      img.className = 'ldt-compare-corner-brand__img';
      img.src = COMPARE_CORNER_LOGO_SRC;
      img.alt = 'Reel Yaks';
      img.decoding = 'async';
      img.loading = 'eager';

      wrap.appendChild(img);
      th.appendChild(wrap);
    });
  }

  function productHandleFromCompareTh(th) {
    if (!th) return null;
    var a = th.querySelector('a.ldt-cp-compare-list-top-item-link[href*="/products"]');
    if (!a) return null;
    var href = a.getAttribute('href');
    if (!href) return null;
    try {
      var u = new URL(href, window.location.origin);
      var m = u.pathname.match(/\/products\/([^/]+)/);
      if (m) return decodeURIComponent(m[1]);
    } catch (err) {
      var m2 = href.match(/\/products\/([^/?#]+)/);
      if (m2) return decodeURIComponent(m2[1]);
    }
    return null;
  }

  function handlesFromProductHeaderRow(tr) {
    var handles = [];
    var ths = tr.querySelectorAll(':scope > th');
    for (var i = 1; i < ths.length; i++) {
      var th = ths[i];
      if (th.querySelector('.ldt-cp-compare-variant-picker')) {
        handles.push(null);
        continue;
      }
      handles.push(productHandleFromCompareTh(th));
    }
    return handles;
  }

  function rewriteComparePricesInString(str) {
    if (!str || typeof str !== 'string') return str;
    return str.replace(/\$\s*([\d,]+)(?:\.(\d{1,3}))?/g, function (full, intPart, decPart) {
      var digits = String(intPart).replace(/,/g, '');
      if (!digits) return full;
      var amount = parseFloat(decPart != null && decPart !== '' ? digits + '.' + decPart : digits);
      if (!Number.isFinite(amount)) return full;
      return '$' + Math.round(amount);
    });
  }

  /** Short label for compare header cards (LDT renders full Shopify titles). */
  function shortCompareProductTitle(full) {
    var t = String(full || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!t) return t;
    if (/^13\.8\s*ft\s+Rocket\b/i.test(t)) return '13.8ft Rocket';
    var markers = [' Fin Drive', ' Propeller Drive', ' Modular Fishing Kayak', ' |'];
    var cut = -1;
    var i;
    for (i = 0; i < markers.length; i++) {
      var idx = t.indexOf(markers[i]);
      if (idx !== -1 && (cut === -1 || idx < cut)) cut = idx;
    }
    if (cut > 0) return t.slice(0, cut).trim();
    return t;
  }

  /** LDT compare header product title — keep full Shopify title (no JS shortening). */
  function shouldSkipCompareTitleShorten(el) {
    if (!el || !el.classList) return false;
    return (
      el.classList.contains('ldt-cp-w-full') &&
      el.classList.contains('ldt-cp-normal-case') &&
      el.classList.contains('ldt-cp-my-2') &&
      el.classList.contains('ldt-cp-compare-list-top-item-title')
    );
  }

  function syncCompareShortTitles(scope) {
    if (!scope) return;
    scope.querySelectorAll('.ldt-cp-compare-list-top-item-title').forEach(function (el) {
      if (shouldSkipCompareTitleShorten(el)) {
        var stored = el.getAttribute('data-ldt-compare-title-full');
        if (stored != null && stored !== '') {
          var cur = el.textContent.replace(/\s+/g, ' ').trim();
          if (cur !== stored.replace(/\s+/g, ' ').trim()) el.textContent = stored;
        }
        return;
      }
      var full = el.getAttribute('data-ldt-compare-title-full');
      if (full == null || full === '') {
        full = el.textContent.replace(/\s+/g, ' ').trim();
        el.setAttribute('data-ldt-compare-title-full', full);
        el.setAttribute('title', full);
      }
      var short = shortCompareProductTitle(full);
      var cur = el.textContent.replace(/\s+/g, ' ').trim();
      if (cur !== short) el.textContent = short;
    });
  }

  function formatMoneyTextNodesUnder(el) {
    if (!el) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      var v = n.nodeValue;
      if (!v || v.indexOf('$') === -1) continue;
      var next = rewriteComparePricesInString(v);
      if (next !== v) n.nodeValue = next;
    }
  }

  /**
   * LDT renders money like `$1,499.00`; show whole dollars only: `$1499` (no thousands separator).
   */
  function syncComparePriceFormatting(scope) {
    if (!scope) return;
    scope
      .querySelectorAll(
        'tr.ldt-cp-compare-list-item-field-price td, tr.ldt-cp-compare-list-item-field-compared_at_price td'
      )
      .forEach(formatMoneyTextNodesUnder);
    scope
      .querySelectorAll('tr.ldt-cp-compare-list-item-products [title="Price"]')
      .forEach(formatMoneyTextNodesUnder);
  }

  function findCompareTables(root) {
    var tables = [];
    root.querySelectorAll('table').forEach(function (t) {
      if (t.querySelector('tr.ldt-cp-compare-list-item-field-price')) tables.push(t);
    });
    return tables;
  }

  function pickCanonicalTable(tables) {
    for (var i = 0; i < tables.length; i++) {
      if (!tables[i].closest('.ldt-cp-fixed')) return tables[i];
    }
    return tables[0] || null;
  }

  function removeCustomRows(table) {
    table.querySelectorAll('tr[data-ldt-custom-spec-row]').forEach(function (r) {
      r.remove();
    });
  }

  function syncCompareProductBadges(scope, specsByHandle) {
    if (!scope || !specsByHandle) return;
    scope.querySelectorAll('tr.ldt-cp-compare-list-item-products').forEach(function (prodRow) {
      var ths = prodRow.querySelectorAll(':scope > th');
      var i;
      for (i = 1; i < ths.length; i++) {
        var th = ths[i];
        if (!th.querySelector('.ldt-cp-product-card')) continue;
        var wrap = th.querySelector('.ldt-cp-compare-list-top-item-image-wrapper');
        if (!wrap) continue;

        wrap.querySelectorAll('.ldt-compare-product-badge').forEach(function (n) {
          n.remove();
        });

        var handle = productHandleFromCompareTh(th);
        var badgeText = '';
        var specRow = null;
        if (typeof handle === 'string' && handle) {
          specRow = specsByHandle[handle] || specsByHandle[handle.toLowerCase()];
        }
        if (specRow) badgeText = specValueToString(specRow.badge);
        if (!badgeText) continue;

        var badge = document.createElement('span');
        badge.className = 'ldt-compare-product-badge';
        badge.textContent = badgeText;
        badge.setAttribute('role', 'status');
        var rmInWrap = wrap.querySelector(':scope > button.ldt-cp-compare-list-top-item-remove');
        if (rmInWrap) rmInWrap.insertAdjacentElement('afterend', badge);
        else wrap.insertBefore(badge, wrap.firstChild);
      }
    });
  }

  function injectMotorBandRow(insertParent, anchorRow, colSpan) {
    var tr = document.createElement('tr');
    tr.setAttribute('data-ldt-custom-spec-row', 'trolling-motors-band');
    tr.className =
      'ldt-cp-divide-x ldt-cp-divide-gray-200 ldt-compare-spec-motor-band-row ldt-cp-compare-list-item-field';

    var th = document.createElement('th');
    th.colSpan = colSpan;
    th.scope = 'row';
    th.className =
      'ldt-cp-text-center ldt-cp-text-sm sm:ldt-cp-text-base ldt-cp-p-3 sm:ldt-cp-p-4 md:ldt-cp-pt-8 ldt-cp-border-t ldt-cp-border-[var(--ldt-border)]';

    var title = document.createElement('div');
    title.className = 'ldt-compare-spec-motor-band-title';
    title.textContent = 'Trolling Motor Mounts';

    th.appendChild(title);
    tr.appendChild(th);
    insertParent.insertBefore(tr, anchorRow);
  }

  function injectOneSpecRow(insertParent, anchorRow, rowDef, variant, handles, specsByHandle, refTh, tdClassList) {
    var tr = document.createElement('tr');
    tr.setAttribute('data-ldt-custom-spec-row', rowDef.key);
    tr.className =
      'ldt-cp-divide-x ldt-cp-divide-gray-200 ldt-cp-compare-list-item-field ldt-compare-injected-spec-row';
    if (variant === 'main') tr.classList.add('ldt-compare-spec-row--main');
    if (variant === 'trolling') tr.classList.add('ldt-compare-spec-row--trolling-motors');

    var th = document.createElement('th');
    if (refTh) th.className = refTh.className;
    if (variant === 'trolling') th.classList.add('ldt-compare-spec-th--trolling');

    var wrap = document.createElement('div');
    wrap.className = 'ldt-cp-flex ldt-cp-gap-1';

    var lblEl = document.createElement('div');
    lblEl.className = 'ldt-cp-column-label ldt-compare-spec-label-cell';
    lblEl.textContent = rowDef.label;
    wrap.appendChild(lblEl);
    th.appendChild(wrap);
    tr.appendChild(th);

    for (var col = 0; col < tdClassList.length; col++) {
      var handle = handles[col];
      var raw = '';
      if (typeof handle === 'string' && handle && specsByHandle[handle]) {
        raw = specsByHandle[handle][rowDef.key] || '';
      }

      var td = document.createElement('td');
      td.className = tdClassList[col];
      if (variant === 'trolling') td.classList.add('ldt-compare-spec-td--trolling');

      var shell = document.createElement('div');
      shell.className =
        'ldt-cp-relative ldt-cp-p-1 sm:ldt-cp-p-2 md:ldt-cp-p-4 ldt-cp-overflow-y-auto ldt-cp-compare-list-item-field-column-content';

      var inner = document.createElement('div');
      inner.className = 'ldt-custom-compare-spec-val';
      inner.setAttribute('title', rowDef.label);

      appendCellContent(inner, handle ? raw : '');

      shell.appendChild(inner);
      td.appendChild(shell);
      tr.appendChild(td);
    }

    insertParent.insertBefore(tr, anchorRow);
  }

  function injectRowsForTable(table, handles, specsByHandle, inject) {
    var priceRow = table.querySelector('tr.ldt-cp-compare-list-item-field-price');
    if (!inject) return;

    var anchorRow =
      table.querySelector('tr.ldt-cp-compare-list-item-field-compared_at_price') ||
      table.querySelector('tr.ldt-cp-compare-list-item-field-description');
    var insertParent = priceRow && priceRow.parentNode;
    if (!priceRow || !insertParent || !anchorRow) return;

    var refTh = priceRow.querySelector(':scope > th.ldt-cp-compare-list-item-attribute');
    var refTds = priceRow.querySelectorAll(':scope > td.ldt-cp-compare-list-item-field-column');
    var tdClassList = Array.from(refTds).map(function (td) {
      return td.className;
    });
    var colSpan = 1 + tdClassList.length;

    SPEC_ROWS_MAIN.forEach(function (rowDef) {
      injectOneSpecRow(insertParent, anchorRow, rowDef, 'main', handles, specsByHandle, refTh, tdClassList);
    });

    injectMotorBandRow(insertParent, anchorRow, colSpan);

    SPEC_ROWS_TROLLING.forEach(function (rowDef) {
      injectOneSpecRow(insertParent, anchorRow, rowDef, 'trolling', handles, specsByHandle, refTh, tdClassList);
    });
  }

  function hasSpecsPayload(norm) {
    if (!norm) return false;
    for (var i = 0; i < REQUIRED_SPEC_KEYS.length; i++) {
      if (norm[REQUIRED_SPEC_KEYS[i]]) return true;
    }
    return false;
  }

  function hideSeatRisersGroupRows(scope) {
    if (!scope) return;
    scope.querySelectorAll('tr.ldt-cp-compare-list-item-group').forEach(function (tr) {
      var anchor = tr.querySelector('th a');
      var t = anchor ? anchor.textContent.replace(/\s+/g, ' ').trim() : '';
      tr.classList.toggle('ldt-compare-hide-seat-risers-row', t.indexOf('Seat Risers') !== -1);
    });
  }

  var compareHorizontalScrollSync = null;

  function teardownCompareHorizontalScrollSync() {
    if (!compareHorizontalScrollSync) return;
    compareHorizontalScrollSync.main.removeEventListener('scroll', compareHorizontalScrollSync.onMain);
    compareHorizontalScrollSync.fixed.removeEventListener('scroll', compareHorizontalScrollSync.onFixed);
    window.removeEventListener('resize', compareHorizontalScrollSync.onResize);
    if (compareHorizontalScrollSync.onWinScroll) {
      window.removeEventListener('scroll', compareHorizontalScrollSync.onWinScroll, true);
    }
    if (compareHorizontalScrollSync.resizeObserver && compareHorizontalScrollSync.mainRoTarget) {
      try {
        compareHorizontalScrollSync.resizeObserver.unobserve(compareHorizontalScrollSync.mainRoTarget);
        compareHorizontalScrollSync.resizeObserver.disconnect();
      } catch (eRo) {}
    }
    compareHorizontalScrollSync = null;
  }

  function bindCompareHorizontalScrollSyncIfNeeded(root) {
    if (!root) return;

    var main = null;
    var wrappers = root.querySelectorAll('.ldt-cp-compare-list-wrapper');
    for (var wi = 0; wi < wrappers.length; wi++) {
      var w = wrappers[wi];
      if (w.closest('.ldt-cp-fixed')) continue;
      if (w.querySelector('.ldt-cp-compare-horizontal-list-table')) {
        main = w;
        break;
      }
    }
    var fixed = root.querySelector('.ldt-cp-fixed.ldt-cp-compare-list-wrapper-sticky');

    if (!main || !fixed) {
      teardownCompareHorizontalScrollSync();
      return;
    }

    if (
      compareHorizontalScrollSync &&
      compareHorizontalScrollSync.main === main &&
      compareHorizontalScrollSync.fixed === fixed
    ) {
      compareHorizontalScrollSync.syncFixedShellGeometry();
      compareHorizontalScrollSync.syncToFixed();
      return;
    }

    teardownCompareHorizontalScrollSync();

    var shellGeomPending = false;
    function syncFixedShellGeometry() {
      if (shellGeomPending) return;
      shellGeomPending = true;
      requestAnimationFrame(function () {
        shellGeomPending = false;
        var r = main.getBoundingClientRect();
        var w = Math.max(0, Math.round(r.width));
        var leftPx = Math.round(r.left);
        fixed.style.setProperty('--ldt-fixed-compare-shell-width', w + 'px');
        fixed.style.setProperty('--ldt-fixed-compare-shell-left', leftPx + 'px');
      });
    }

    /**
     * Programmatic `scrollLeft` assignments fire `scroll` synchronously; a boolean latch cleared in the same
     * synchronous turn does not suppress the echoed event — leads to jitter on touch / momentum scrolling.
     */
    var suppressHorizontalScrollEcho = 0;

    function syncToFixed() {
      if (suppressHorizontalScrollEcho) return;
      var m = main.scrollLeft;
      if (fixed.scrollLeft === m) return;
      suppressHorizontalScrollEcho++;
      try {
        fixed.scrollLeft = m;
      } finally {
        suppressHorizontalScrollEcho--;
      }
    }
    function syncToMain() {
      if (suppressHorizontalScrollEcho) return;
      var f = fixed.scrollLeft;
      if (main.scrollLeft === f) return;
      suppressHorizontalScrollEcho++;
      try {
        main.scrollLeft = f;
      } finally {
        suppressHorizontalScrollEcho--;
      }
    }
    function onMainScroll() {
      if (suppressHorizontalScrollEcho) return;
      syncToFixed();
    }
    function onFixedScroll() {
      if (suppressHorizontalScrollEcho) return;
      syncToMain();
    }
    function onResize() {
      syncFixedShellGeometry();
      syncToFixed();
    }

    function onWinScroll() {
      syncFixedShellGeometry();
    }

    main.addEventListener('scroll', onMainScroll, { passive: true });
    fixed.addEventListener('scroll', onFixedScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('scroll', onWinScroll, { passive: true, capture: true });

    var ro = null;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(onResize);
      ro.observe(main);
    }

    compareHorizontalScrollSync = {
      main: main,
      fixed: fixed,
      onMain: onMainScroll,
      onFixed: onFixedScroll,
      onResize: onResize,
      onWinScroll: onWinScroll,
      resizeObserver: ro,
      mainRoTarget: main,
      syncToFixed: syncToFixed,
      syncFixedShellGeometry: syncFixedShellGeometry,
    };

    syncFixedShellGeometry();
    syncToFixed();
  }

  function syncCompareMetaobjectRows() {
    var root = document.getElementById('ldt-app-proxy-root');
    if (!root) return;

    function tailPickerAndScroll() {
      syncComparePriceFormatting(root);
      syncCompareShortTitles(root);
      scheduleProductPickerAllowlist();
      bindCompareHorizontalScrollSyncIfNeeded(root);
    }

    hideSeatRisersGroupRows(root);
    syncCompareCornerLogo(root);
    syncStickyToolbarCornerLogo(root);

    var specsByHandle = loadSpecsByHandle();
    var tables = findCompareTables(root);
    if (!tables.length) {
      tailPickerAndScroll();
      return;
    }

    var canon = pickCanonicalTable(tables);
    if (!canon) {
      tailPickerAndScroll();
      return;
    }

    var prodRow = canon.querySelector('tr.ldt-cp-compare-list-item-products');
    if (!prodRow) {
      tailPickerAndScroll();
      return;
    }

    syncCompareProductBadges(root, specsByHandle);

    var handles = handlesFromProductHeaderRow(prodRow);

    var injectSpecs =
      handles.filter(function (h) {
        return typeof h === 'string' && h.length > 0;
      }).length > 0 &&
      handles.some(function (h) {
        return typeof h === 'string' && h.length > 0 && hasSpecsPayload(specsByHandle[h]);
      });

    var expectedCustomRowCount = SPEC_ROWS_MAIN.length + SPEC_ROWS_TROLLING.length + 1;
    var syncFingerprint =
      handles
        .map(function (h) {
          return typeof h === 'string' ? h : '';
        })
        .join('\0') +
      '\0' +
      (injectSpecs ? '1' : '0');

    var allInjectedRowsIntact = (function () {
      var n = canon.querySelectorAll('tr[data-ldt-custom-spec-row]').length;
      return injectSpecs ? n === expectedCustomRowCount : n === 0;
    })();

    if (syncFingerprint === lastSpecSyncFingerprint && allInjectedRowsIntact) {
      hideSeatRisersGroupRows(root);
      syncCompareCornerLogo(root);
      syncStickyToolbarCornerLogo(root);
      syncCompareProductBadges(root, specsByHandle);
      tailPickerAndScroll();
      return;
    }

    tables.forEach(function (table) {
      removeCustomRows(table);
      var pr = table.querySelector('tr.ldt-cp-compare-list-item-products');
      if (!pr) return;
      var hRow = handlesFromProductHeaderRow(pr);

      injectRowsForTable(table, hRow, specsByHandle, injectSpecs);
    });
    lastSpecSyncFingerprint = syncFingerprint;
    tailPickerAndScroll();
  }

  var stickyScheduled = false;
  function requestSyncSticky() {
    if (stickyScheduled) return;
    stickyScheduled = true;
    requestAnimationFrame(function () {
      stickyScheduled = false;
      syncLdtStickyTop();
    });
  }

  var specTimer = null;
  function scheduleSpecSync() {
    if (specTimer) clearTimeout(specTimer);
    specTimer = setTimeout(function () {
      specTimer = null;
      withLdtCompareSubtreeObserverPaused(syncCompareMetaobjectRows);
      withLdtCompareSubtreeObserverPaused(ryakSyncViewProductButtons);
      ryakApplyVariantAutoSelect();
    }, 150);
  }

  function isLdtCompareBrandElement(node) {
    return (
      node &&
      node.nodeType === 1 &&
      node.classList &&
      node.classList.contains('ldt-compare-corner-brand')
    );
  }

  function isLdtComparePassiveSubtreeNode(node) {
    return (
      isLdtCompareBrandElement(node) ||
      (node &&
        node.nodeType === 1 &&
        node.classList &&
        node.classList.contains('ldt-compare-product-badge'))
    );
  }

  function mutationsAreOnlyOurCompareBranding(mutations) {
    if (!mutations || !mutations.length) return false;
    var sawChildListChange = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type !== 'childList') continue;
      var k;
      for (k = 0; k < m.addedNodes.length; k++) {
        var a = m.addedNodes[k];
        if (a.nodeType === 8 || a.nodeType === 10) continue;
        if (a.nodeType !== 1) return false;
        if (!isLdtComparePassiveSubtreeNode(a)) return false;
      }
      for (k = 0; k < m.removedNodes.length; k++) {
        var r = m.removedNodes[k];
        if (r.nodeType === 8 || r.nodeType === 10) continue;
        if (r.nodeType !== 1) return false;
        if (!isLdtComparePassiveSubtreeNode(r)) return false;
      }
      if (m.addedNodes.length || m.removedNodes.length) sawChildListChange = true;
    }
    return sawChildListChange;
  }

  function mutationsOnlyProductPickerOptionChurn(mutations) {
    if (!mutations || !mutations.length) return false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type !== 'childList') return false;
      var target = m.target;
      if (!target || target.nodeType !== 1) return false;
      if (!target.closest) return false;
      if (!target.closest('.ldt-cp-compare-variant-picker')) return false;
      if (
        (!target.matches || !target.matches('select.ldt-cp-product-select')) &&
        (!target.matches || !target.matches('select.ldt-cp-collection-select'))
      ) {
        return false;
      }

      var j;
      for (j = 0; j < m.addedNodes.length; j++) {
        var a = m.addedNodes[j];
        if (a.nodeType === 8 || a.nodeType === 10 || a.nodeType === 3) continue;
        if (a.nodeType !== 1) return false;
        if (String(a.tagName).toUpperCase() !== 'OPTION') return false;
      }
      for (j = 0; j < m.removedNodes.length; j++) {
        var r = m.removedNodes[j];
        if (r.nodeType === 8 || r.nodeType === 10 || r.nodeType === 3) continue;
        if (r.nodeType !== 1) return false;
        if (String(r.tagName).toUpperCase() !== 'OPTION') return false;
      }
    }
    return true;
  }

  var ldtSubtreeObserverInstalled = false;
  function watchLdtMount() {
    var el = document.getElementById('ldt-app-proxy-root');
    if (!el || ldtSubtreeObserverInstalled) return;
    ldtSubtreeObserverInstalled = true;
    ldtCompareSubtreeObserver = new MutationObserver(function (mutationList) {
      requestSyncSticky();
      if (mutationsAreOnlyOurCompareBranding(mutationList)) return;
      if (mutationsOnlyProductPickerOptionChurn(mutationList)) {
        scheduleProductPickerAllowlist();
        scheduleCollectionSelectDefault();
        return;
      }
      scheduleSpecSync();
      scheduleCollectionSelectDefault();
    });
    ldtCompareSubtreeObserver.observe(el, { childList: true, subtree: true });
  }

  var rootObservationStarted = false;
  function ensureLdtMountObserver() {
    if (document.getElementById('ldt-app-proxy-root')) {
      watchLdtMount();
      return;
    }
    if (rootObservationStarted) return;
    rootObservationStarted = true;
    var rm = new MutationObserver(function () {
      if (!document.getElementById('ldt-app-proxy-root')) return;
      rm.disconnect();
      rootObservationStarted = false;
      watchLdtMount();
      scheduleSpecSync();
    });
    rm.observe(document.body, { childList: true, subtree: true });
  }

  // =====================================================================
  // AUTO-SELECT BEST VARIANT + VIEW PRODUCT BUTTON
  // =====================================================================

  var RYAK_SF_URL = window.wsStoreFrontUrl || 'https://reelyaks.myshopify.com/api/2025-07/graphql.json';

  /** Extract the shortest delivery window (in weeks) from a variant title.
   *  e.g. "Cyan Gray / in 1 - 2 weeks" → 1
   *       "Hornet / in 8 - 11 weeks / Standard" → 8
   *       "Blue Gray / 2 - 3 weeks / Standard" → 2
   */
  function ryakExtractMinWeeks(title) {
    var t = String(title || '');
    var m = t.match(/(?:in\s+)?(\d+)\s*[-–—]\s*\d+\s*weeks?/i);
    if (m) return parseInt(m[1], 10);
    var m2 = t.match(/(\d+)\s*weeks?/i);
    if (m2) return parseInt(m2[1], 10);
    return 999; // no delivery window found → lowest priority
  }

  /** Fetch availableForSale for a list of variant GIDs via the Storefront API. */
  function ryakFetchVariantAvailability(gids, cb) {
    var token = (window.LDT_COMPARE && window.LDT_COMPARE.accessToken) || '';
    if (!token || !gids || !gids.length) { cb({}); return; }
    var ids = gids.map(function (g) { return JSON.stringify(g); }).join(',');
    var query = '{nodes(ids:[' + ids + ']){...on ProductVariant{id availableForSale}}}';
    fetch(RYAK_SF_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query: query }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var out = {};
        var nodes = data && data.data && data.data.nodes;
        if (Array.isArray(nodes)) {
          nodes.forEach(function (n) { if (n && n.id) out[n.id] = !!n.availableForSale; });
        }
        cb(out);
      })
      .catch(function () { cb({}); });
  }

  /**
   * Given a variant <select> that just appeared, fetch availability and select
   * the best option: prefer in-stock variants, then shortest delivery window.
   */
  function ryakAutoSelectBestVariant(sel) {
    if (!sel || sel.dataset.ryakAutoApplied) return;
    sel.dataset.ryakAutoApplied = '1';

    var opts = Array.from(sel.options).filter(function (o) { return o.value; });
    if (!opts.length) return;

    ryakFetchVariantAvailability(opts.map(function (o) { return o.value; }), function (avail) {
      var scored = opts.map(function (o) {
        return { opt: o, inStock: !!avail[o.value], weeks: ryakExtractMinWeeks(o.text) };
      });

      var inStock = scored.filter(function (s) { return s.inStock; });
      // If nothing is in stock, fall back to out-of-stock options sorted by delivery window
      var pool = (inStock.length ? inStock : scored).slice().sort(function (a, b) {
        return a.weeks - b.weeks;
      });

      var best = pool[0];
      if (!best) return;

      withLdtCompareSubtreeObserverPaused(function () {
        sel.value = best.opt.value;
        dispatchSelectNativeChange(sel);
      });
    });
  }

  /** Scan all variant selects on the page and auto-select unprocessed ones. */
  function ryakApplyVariantAutoSelect() {
    var root = document.getElementById('ldt-app-proxy-root');
    if (!root) return;
    root.querySelectorAll('select.ldt-cp-variant-select').forEach(function (sel) {
      if (!sel.dataset.ryakAutoApplied) ryakAutoSelectBestVariant(sel);
    });
  }

  /**
   * Add a "View Product" button below the ATC button for every loaded product column.
   * The button href is read from the existing "Learn more" link at click time so it
   * always reflects the currently selected variant.
   */
  function ryakSyncViewProductButtons() {
    var root = document.getElementById('ldt-app-proxy-root');
    if (!root) return;
    root.querySelectorAll('tr.ldt-cp-compare-list-item-products > th').forEach(function (th) {
      // Skip empty picker slots
      if (th.querySelector('.ldt-cp-compare-variant-picker')) return;
      // Skip if already added
      if (th.querySelector('.ryak-view-product-btn')) return;

      var actions = th.querySelector('.ldt-cp-product-card-actions');
      if (!actions) return;
      var pdpLink = actions.querySelector('a[href*="/products/"]');
      if (!pdpLink) return;

      var btn = document.createElement('a');
      btn.className = 'ryak-view-product-btn';
      btn.textContent = 'View Product';
      btn.setAttribute('href', pdpLink.getAttribute('href') || '#');

      // Always read the live "Learn more" href at click time (variant may change)
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var live = actions.querySelector('a[href*="/products/"]');
        window.location.href = live ? live.href : btn.getAttribute('href');
      });

      // Insert right after the ATC button
      var atcBtn = actions.querySelector('button');
      if (atcBtn) {
        atcBtn.insertAdjacentElement('afterend', btn);
      } else {
        actions.insertBefore(btn, pdpLink);
      }
    });
  }

  // -----------------------------------------------------------------------
  // VARIANT MIRROR: show variant select in main (non-sticky) picker too
  // -----------------------------------------------------------------------

  /** Helper: find the main (non-fixed, non-translate-y) compare wrapper. */
  function ryakGetMainWrapper() {
    var root = document.getElementById('ldt-app-proxy-root');
    if (!root) return null;
    var mainW = null;
    root.querySelectorAll('[class*="ldt-cp-compare-list-wrapper"]').forEach(function (w) {
      if (!w.classList.contains('ldt-cp-fixed') && !w.classList.contains('ldt-cp-translate-y')) {
        mainW = w;
      }
    });
    return mainW;
  }

  /**
   * For each column where the FIXED (sticky) header has a variant select,
   * mirror that select into the corresponding MAIN table picker so customers
   * can see and change the delivery date without needing to scroll.
   * Changes in the mirror propagate up to the real fixed select via events.
   */
  function ryakMirrorVariantSelectToMain() {
    var root = document.getElementById('ldt-app-proxy-root');
    if (!root) return;
    var fixed = root.querySelector('.ldt-cp-fixed');
    if (!fixed) return;
    var mainW = ryakGetMainWrapper();
    if (!mainW) return;

    var fixedRow = fixed.querySelector('tr.ldt-cp-compare-list-item-products');
    var mainRow = mainW.querySelector('tr.ldt-cp-compare-list-item-products');
    if (!fixedRow || !mainRow) return;

    var fixedCells = Array.from(fixedRow.cells);
    var mainCells = Array.from(mainRow.cells);

    fixedCells.forEach(function (fixedCell, colIdx) {
      var fixedVarSel = fixedCell.querySelector('select.ldt-cp-variant-select');
      if (!fixedVarSel) return;

      var mainCell = mainCells[colIdx];
      if (!mainCell) return;

      var mainPicker = mainCell.querySelector('.ldt-cp-compare-variant-picker');
      if (!mainPicker) return;

      // Don't duplicate
      if (mainPicker.querySelector('.ryak-var-mirror')) return;

      // Clone the fixed variant select (strip auto-applied flag so auto-select can still run)
      var mirror = fixedVarSel.cloneNode(true);
      mirror.classList.add('ryak-var-mirror');
      delete mirror.dataset.ryakAutoApplied;
      mirror.value = fixedVarSel.value;

      // Sync: customer changes the main mirror → update the real fixed select + fire LDT events
      mirror.addEventListener('change', function () {
        withLdtCompareSubtreeObserverPaused(function () {
          fixedVarSel.value = mirror.value;
          dispatchSelectNativeChange(fixedVarSel);
        });
      });

      // Sync: auto-select changes the fixed select → keep mirror in sync
      fixedVarSel.addEventListener('change', function () {
        if (mirror.value !== fixedVarSel.value) mirror.value = fixedVarSel.value;
      });

      withLdtCompareSubtreeObserverPaused(function () {
        mainPicker.appendChild(mirror);
      });
    });
  }

  // -----------------------------------------------------------------------
  // VARIANT SELECT IN LOADED PRODUCT CARDS (pre-loaded from URL)
  // -----------------------------------------------------------------------

  /** Fetch variant title + all sibling variants for a list of variant GIDs. */
  function ryakFetchVariantDetails(gids, cb) {
    var token = (window.LDT_COMPARE && window.LDT_COMPARE.accessToken) || '';
    if (!token || !gids || !gids.length) { cb({}); return; }
    var ids = gids.map(function (g) { return JSON.stringify(g); }).join(',');
    var query = '{nodes(ids:[' + ids + ']){...on ProductVariant{id title product{variants(first:30){nodes{id title availableForSale}}}}}}';
    fetch(RYAK_SF_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query: query }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var out = {};
        var nodes = data && data.data && data.data.nodes;
        if (Array.isArray(nodes)) {
          nodes.forEach(function (n) {
            if (n && n.id) {
              out[n.id] = {
                title: n.title,
                siblings: n.product && n.product.variants ? n.product.variants.nodes : [],
              };
            }
          });
        }
        cb(out);
      })
      .catch(function () { cb({}); });
  }

  /**
   * For each loaded product card in the main table inject a delivery-date <select>
   * above the ATC button so customers can see (and change) which variant is selected.
   * When the customer changes the select and then clicks ATC, we intercept the click
   * and add the correct variant to cart (see the ATC interceptor below).
   */
  function ryakShowVariantSelectInCard() {
    var mainW = ryakGetMainWrapper();
    if (!mainW) return;

    var productRow = mainW.querySelector('tr.ldt-cp-compare-list-item-products');
    if (!productRow) return;

    var gidsToFetch = [];
    var cellMap = {}; // gid → actions element

    Array.from(productRow.cells).forEach(function (cell) {
      if (cell.querySelector('.ldt-cp-compare-variant-picker')) return; // empty slot
      if (cell.querySelector('.ryak-variant-card-sel')) return;         // already done

      var actions = cell.querySelector('.ldt-cp-product-card-actions');
      if (!actions) return;

      var link = actions.querySelector('a[href*="/products/"]');
      if (!link) return;

      var m = link.href.match(/[?&]variant=(\d+)/);
      if (!m) return;

      var gid = 'gid://shopify/ProductVariant/' + m[1];
      gidsToFetch.push(gid);
      cellMap[gid] = actions;
    });

    if (!gidsToFetch.length) return;

    ryakFetchVariantDetails(gidsToFetch, function (data) {
      Object.keys(data).forEach(function (gid) {
        var info = data[gid];
        var actions = cellMap[gid];
        if (!actions || actions.querySelector('.ryak-variant-card-sel')) return;
        if (!info.siblings || !info.siblings.length) return;

        var sel = document.createElement('select');
        sel.className = 'ryak-variant-card-sel ldt-cp-p-2 ldt-cp-border ldt-cp-border-primary ldt-cp-rounded ldt-cp-w-full ldt-cp-text-sm';

        // Sort by delivery window (shortest first) to match auto-select ordering
        var sorted = info.siblings.slice().sort(function (a, b) {
          return ryakExtractMinWeeks(a.title) - ryakExtractMinWeeks(b.title);
        });
        sorted.forEach(function (v) {
          var opt = new Option(v.title, v.id);
          if (v.id === gid) opt.selected = true;
          sel.appendChild(opt);
        });

        var atcBtn = actions.querySelector('button');
        withLdtCompareSubtreeObserverPaused(function () {
          if (atcBtn) {
            actions.insertBefore(sel, atcBtn);
          } else {
            actions.insertBefore(sel, actions.firstChild);
          }
        });
      });
    });
  }

  // Inject CSS for View Product button + variant selects (runs once)
  (function () {
    if (document.getElementById('ryak-view-product-style')) return;
    var style = document.createElement('style');
    style.id = 'ryak-view-product-style';
    style.textContent = [
      '.ryak-view-product-btn {',
      '  display: block;',
      '  width: 100%;',
      '  margin: 4px 0 2px;',
      '  padding: 8px 4px;',
      '  text-align: center;',
      '  font-size: 0.8125rem;',
      '  font-weight: 600;',
      '  letter-spacing: 0.02em;',
      '  border: 1.5px solid var(--color-button, #00b5a5);',
      '  border-radius: 4px;',
      '  color: var(--color-button, #00b5a5);',
      '  background: transparent;',
      '  text-decoration: none;',
      '  cursor: pointer;',
      '  box-sizing: border-box;',
      '  transition: background 0.15s ease, color 0.15s ease;',
      '}',
      '.ryak-view-product-btn:hover {',
      '  background: var(--color-button, #00b5a5);',
      '  color: #fff;',
      '  text-decoration: none;',
      '}',
      /* variant mirror + card select */
      '.ryak-var-mirror, .ryak-variant-card-sel {',
      '  display: block;',
      '  width: 100%;',
      '  margin: 4px 0;',
      '  box-sizing: border-box;',
      '  font-size: 0.8125rem;',
      '  cursor: pointer;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  })();

  // Track when customer explicitly changes one of our card variant selects
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ryak-variant-card-sel')) {
      e.target.dataset.ryakUserChanged = '1';
    }
  }, true);

  /**
   * Intercept ATC clicks when the customer has changed our card variant select.
   * We use the customer's chosen variant GID to POST to /cart/add.js directly,
   * bypassing LDT's (possibly stale) internal variant state.
   * Only fires when ryakUserChanged is set — normal clicks pass through to LDT.
   */
  document.addEventListener('click', function (e) {
    var atcBtn = e.target && e.target.closest
      ? e.target.closest('.ldt-cp-compare-list-top-item-add-to-cart')
      : null;
    if (!atcBtn) return;

    var actions = atcBtn.closest ? atcBtn.closest('.ldt-cp-product-card-actions') : null;
    if (!actions) return;

    var ourSel = actions.querySelector('.ryak-variant-card-sel');
    if (!ourSel || !ourSel.value || !ourSel.dataset.ryakUserChanged) return;

    var variantId = ourSel.value.replace('gid://shopify/ProductVariant/', '');
    if (!variantId || isNaN(parseInt(variantId, 10))) return;

    e.stopPropagation();
    e.preventDefault();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = cartRoot + 'cart';
      })
      .catch(function () {
        // If the direct add fails, fall back to LDT by firing a plain click
        ourSel.removeAttribute('data-ryak-user-changed');
        atcBtn.click();
      });
  }, true);

  // Listen for product select changes to trigger variant auto-select + mirroring
  // (captures before LDT's own handler so we can schedule after the app renders)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('ldt-cp-product-select') && t.value) {
      setTimeout(ryakApplyVariantAutoSelect, 600);
      setTimeout(ryakMirrorVariantSelectToMain, 700);
      setTimeout(ryakShowVariantSelectInCard, 800);
      setTimeout(ryakApplyVariantAutoSelect, 1500);
      setTimeout(ryakMirrorVariantSelectToMain, 1600);
      setTimeout(ryakShowVariantSelectInCard, 1700);
      setTimeout(ryakApplyVariantAutoSelect, 3000);
      setTimeout(ryakMirrorVariantSelectToMain, 3100);
      setTimeout(ryakShowVariantSelectInCard, 3200);
    }
  }, true);

  // =====================================================================
  // END AUTO-SELECT / VIEW PRODUCT
  // =====================================================================

  window.addEventListener('scroll', requestSyncSticky, { passive: true });
  window.addEventListener('resize', requestSyncSticky);

  function boot() {
    requestSyncSticky();
    ensureLdtMountObserver();
    withLdtCompareSubtreeObserverPaused(syncCompareMetaobjectRows);
    scheduleCollectionSelectDefault();
    setTimeout(requestSyncSticky, 120);
    setTimeout(scheduleSpecSync, 200);
    setTimeout(function () {
      requestSyncSticky();
      scheduleSpecSync();
      scheduleCollectionSelectDefault();
    }, 900);
    // Apply new features after initial render
    setTimeout(ryakSyncViewProductButtons, 1200);
    setTimeout(ryakApplyVariantAutoSelect, 1200);
    setTimeout(ryakMirrorVariantSelectToMain, 1300);
    setTimeout(ryakShowVariantSelectInCard, 1400);
    setTimeout(ryakSyncViewProductButtons, 2500);
    setTimeout(ryakApplyVariantAutoSelect, 2500);
    setTimeout(ryakMirrorVariantSelectToMain, 2600);
    setTimeout(ryakShowVariantSelectInCard, 2700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
